import React from "react";

export const EnergyManagement = [
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col50">
      <h4 className="slideTitle">
        Energy Management enables enterprise-wide visibility and control of
        energy use across multiple sites and facilities with no upfront capital
        expenditure or maintenance.
      </h4>
      <p>
        Reduce costs up to 30% on your monthly energy bill through automated
        controls, advanced analytics, and actionable recommendations.
      </p>
      <ul className="shell_bullets_list">
        <li>
          <strong>Simple, intelligent control</strong> - Easily edit site hours,
          HVAC and lighting control schedule across multiple sites
        </li>
        <li>
          <strong>Smart alarms</strong> - Alert users to the most important
          operational issues with fine-tuned alarms
        </li>
        <li>
          <strong>Reports & analytics</strong> - Review and compare site
          performance through intuitive graphs, reports, and analytics
        </li>
        <li>
          <strong>Energy manager mobile</strong> - Access your energy data from
          any computer, tablet, or mobile device
        </li>
      </ul>
    </div>
    <div className="colRight col50 solidColourContainer">
      <h4 className="slideTitle">Key Benefits</h4>
      <ul className="shell_bullets_list icons_list">
        <li>
          <img
            src="images/energyManagement-costReduction.png"
            width="auto"
            height="50px"
            alt=""
          />
          <span>
            Immediate energy and operating <strong>cost reductions</strong>
          </span>
        </li>
        <li>
          <img
            src="images/energyManagement-increaseComfort.png"
            width="auto"
            height="50px"
            alt=""
          />
          <span>
            <strong>Increased comfort</strong> for building occupants
          </span>
        </li>
        <li>
          <img
            src="images/energyManagement-preventiveNotification.png"
            width="auto"
            height="50px"
            alt=""
          />
          <span>
            <strong>Preventive notification</strong> of equipment failure
          </span>
        </li>
        <li>
          <img
            src="images/energyManagement-actionableInsights.png"
            width="auto"
            height="50px"
            alt=""
          />
          <span>
            <strong>Actionable insights</strong> from analytics and reporting
          </span>
        </li>
      </ul>
    </div>
  </div>,
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col70">
      <h4 className="slideTitle">
        Rely on Shell Energy’s deep technical expertise, risk and regulatory
        experience, and industry-leading business processes to optimize facility
        efficiency, uptime and utilization, and get the most out of your energy
        assets.
      </h4>
      <ul className="shell_bullets_list">
        <li>Power optimization strategy and scheduling</li>
        <li>
          Short and long-term hedging with daily support from the Shell trade
          desk
        </li>
        <li>Market access to RECs for renewable power producers</li>
        <li>24/7 trading desk</li>
      </ul>
      <img
        alt=""
        src="images/energyManagement-banner.png"
        width="100%"
        height="auto"
      />
    </div>
    <div className="colRight col30 solidColourContainer grey">
      <p>We manage facilities which produce power from various sources</p>
      <div class="d-flex split2x2">
        <p>
          <img
            alt=""
            src="images/asset-and-energy-management-natural-gas.svg"
            height="auto"
            width="auto"
          />
          Natural gas
        </p>
        <p>
          <img
            alt=""
            src="images/asset-and-energy-management-solar.svg"
            height="auto"
            width="auto"
          />
          Solar
        </p>
        <p>
          <img
            alt=""
            src="images/asset-and-energy-management-wind.svg"
            height="auto"
            width="auto"
          />
          Wind
        </p>
        <p>
          <img
            alt=""
            src="images/asset-and-energy-management-biomass.svg"
            height="auto"
            width="auto"
          />
          Biomass
        </p>
      </div>
    </div>
  </div>,
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col50">
      <h4 className="slideTitle">Submetering</h4>
      <p>
        <strong>
          Gain granular, real-time visibility into your energy usage, plus find
          efficiency improvements, take control, and manage energy holistically.
        </strong>
      </p>
      <ul className="shell_bullets_list">
        <li>
          Identify equipment inefficiencies and validate repairs using real-time
          data across multiple sites and facilities
        </li>
        <li>
          View equipment-level energy consumption for insight into usage trends
          that can be used to identify savings opportunities
        </li>
        <li>
          Diagnose issues on-site or remotely using real-time data to improve
          service call efficiency
        </li>
        <li>
          Notify designated employees immediately when a meaningful issue occurs
          with smart alarms
        </li>
      </ul>
      <img
        src="images/submeteringArrows.JPG"
        width="100%"
        height="auto"
        alt=""
      />
    </div>
    <div className="colRight col50">
      <h4 className="slideTitle">How it works</h4>
      <img src="images/submeteringHIW.JPG" width="100%" height="auto" alt="" />
    </div>
  </div>,
];
